import { Truck, Trash2, Recycle } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const services = [
  {
    icon: Trash2,
    title: 'Coleta Especializada',
    description:
      'Recolhimento seguro de resíduos infectantes, químicos e perfurocortantes em estabelecimentos de saúde, seguindo rigorosamente as normas da ANVISA.',
  },
  {
    icon: Truck,
    title: 'Transporte Seguro',
    description:
      'Frota rastreada e adaptada para o transporte de cargas perigosas, garantindo a integridade dos resíduos do ponto de coleta até o destino.',
  },
  {
    icon: Recycle,
    title: 'Destinação Final',
    description:
      'Tratamento e disposição final Ambientalmente Adequados, com emissão de manifesto (MTR) para conformidade legal.',
  },
]

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            O Que Fazemos
          </h2>
          <p className="text-gray-600">
            Cuidamos de todo o ciclo dos resíduos (RSS) do seu negócio,
            garantindo segurança jurídica e ambiental. Tudo isso de forma ágil e
            segura.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card
              key={index}
              className="border-t-4 border-t-primary hover:shadow-lg transition-shadow duration-300"
            >
              <CardHeader className="pb-2">
                <div className="w-14 h-14 rounded-lg bg-green-100 flex items-center justify-center mb-6 text-primary">
                  <service.icon className="w-8 h-8" />
                </div>
                <CardTitle className="text-xl font-bold text-gray-900">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
